/** Represents the error status codes. */
export var ApiErrorStatusCode;
(function (ApiErrorStatusCode) {
    ApiErrorStatusCode[ApiErrorStatusCode["BadRequest"] = 400] = "BadRequest";
    ApiErrorStatusCode[ApiErrorStatusCode["Unauthorized"] = 401] = "Unauthorized";
    ApiErrorStatusCode[ApiErrorStatusCode["Forbidden"] = 403] = "Forbidden";
    ApiErrorStatusCode[ApiErrorStatusCode["NotFound"] = 404] = "NotFound";
    ApiErrorStatusCode[ApiErrorStatusCode["Conflict"] = 409] = "Conflict";
    ApiErrorStatusCode[ApiErrorStatusCode["InternalServerError"] = 500] = "InternalServerError";
    ApiErrorStatusCode[ApiErrorStatusCode["BadGateway"] = 502] = "BadGateway";
    ApiErrorStatusCode[ApiErrorStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
})(ApiErrorStatusCode || (ApiErrorStatusCode = {}));
//# sourceMappingURL=axiosBaseQuery.types.js.map